export default __webpack_public_path__ + "img/camp.0846af89.svg";